
import CommonTemplate from "@/components/common-template.vue";
import { queryNavList } from "@/api/header";
import { queyHtmlMoudle } from "@/api/index";
import { footerNav } from "@/api/footer";
import CommonLinks from "@/components/CommonLinks.vue";
import CommonHearder from "~/components/common-hearder.vue";

export default {
  scrollToTop: true,

  name: "index",
  layout: "index",
  components: {
    CommonTemplate,
    CommonLinks,
    CommonHearder,
  },
  head: {
    title: "巨得-商城源码，商城小程序，商城购物系统",
    meta: [
      {
        name: "keywords",
        content:
          "巨得科技,商城源码,开源商城系统,在线商城,源码,小程序商城源码,B2C商城源码,B2B2C商城源码,JAVA商城源码,多商户商城源码,在线商城源码,社区团购源码,O2O商城源码,S2B2C商城源码,app商城源码",
      },
      {
        name: "description",
        content:
          "巨得科技提供最新最全的商城源码下载，在线商城系统源码分享等，帮助开发者快速搭建个性化在线商城。所有商城源码均为开源源码，包含B2C商城、B2B2C商城、S2B2C商城、O2O商城、社区团购等多种商城源码。快来选择适合的商城源码，开启你的电商商城之旅吧！",
      },
    ],
  },
  async asyncData({ store }) {
    //查询所有导航
    const resp = await queryNavList();
    const navData =
      resp && resp.data && Array.isArray(resp.data.data) ? resp.data.data : [];
    const navarrs = navData;
    const product_Arrs =
      navData[1] && Array.isArray(navData[1].children)
        ? navData[1].children
        : [];
    //首页默认没有id 所默认取第一个为首页
    const firstNavId = navarrs[0] ? navarrs[0].id : undefined;
    const res = firstNavId
      ? await queyHtmlMoudle(firstNavId)
      : { data: { data: [] } };
    const navList =
      res && res.data && Array.isArray(res.data.data) ? res.data.data : [];

    // console.log(
    //   navList
    //     .filter((item) => item.dynamicElement.length > 0)
    //     .map((item) => item.dynamicElement)
    // );
    store.commit("changeindexArr", navList);

    const resp1 = await footerNav();
    const footer =
      resp1 && resp1.data && resp1.data.data ? resp1.data.data : {};

    store.commit("changeTel", footer.telephone || "");
    const friendlyLinks =
      footer.friendlyLinks && footer.friendlyLinks[0]
        ? footer.friendlyLinks[0].title
        : "";
    return {
      navList,
      product_Arrs,
      navarrs,
      friendlyLinks,
      footer,
    };
  },
  data() {
    return {
      isBottom: false,
    };
  },
};
